module.exports = __webpack_public_path__ + "media/images/tip_select_list-e9805dab45d03ea8547a7267c585a145.png";